import {
    useRef,
    useState
} from 'react';

import { SimpleGrid, Text } from '@mantine/core';

import { useRatePlans } from '../hooks/useRatePlans.ts';
import { useRatePlansSelection } from '../hooks/useRatePlansSelection.ts';
import { FormDrawer } from '../drawers/FormDrawer.tsx';
import { update } from '../services/RatePlansService.ts';

import {
    MantineDataTable,
    TableSearchForm,
} from '@flexinet/ui-components';
import { DataTableColumn } from "mantine-datatable";
import { DataTableTokenPagination } from "../../../components/DataTableTokenPagination.tsx";
import { RatePlan } from '../types';
import { useQueryClient } from '@tanstack/react-query';

export const RecordsTable = () => {
    const {selectedRecords, setSelectedRecords} = useRatePlansSelection();
    const [drawerOpened, setDrawerOpened] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState<RatePlan | null>(null);
    const queryClient = useQueryClient();

    const {
        items,
        totalCount,
        loading,
        nextToken,
        fetchRecords,
        handleFilterByKeyword
    } = useRatePlans();

    const scrollViewportRef = useRef<HTMLDivElement>(null);

    const handleRecordClick = (record: RatePlan) => {
        setSelectedRecord(record);
        setDrawerOpened(true);
    };

    const handleDrawerSubmit = async (values: RatePlan) => {
        if (selectedRecord?.id) {
            const { createdByUsername: _createdByUsername, createdBy: _createdBy, created: _created, updated: _updated, ...rest } = values;
            await update(selectedRecord.id, rest as RatePlan);
            queryClient.invalidateQueries({ queryKey: ['rate-plans'] });
        }
    };

    const columns: DataTableColumn<RatePlan>[] = [
        {
            accessor: 'name',
            title: 'Rate Plan',
            render: (record: RatePlan) => (
                <Text
                    c="blue"
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleRecordClick(record)}
                >
                    {record.name}
                </Text>
            )
        },
        { accessor: 'created', title: 'Created' },
    ];

    return (
        <SimpleGrid verticalSpacing='xl' m='sm'>
            <TableSearchForm handleFilterByKeyword={handleFilterByKeyword} />

            <MantineDataTable
                columns={columns}
                records={items}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={setSelectedRecords}
                fetching={loading}
                onScrollToBottom={() => fetchRecords()}
                scrollViewportRef={scrollViewportRef}
                withTableBorder={true}
            />

            <DataTableTokenPagination totalCount={totalCount.toString()} nextToken={nextToken} handleLoadMore={fetchRecords} />

            <FormDrawer
                record={selectedRecord || {} as RatePlan}
                handleSubmit={handleDrawerSubmit}
                opened={drawerOpened}
                onClose={() => setDrawerOpened(false)}
            />
        </SimpleGrid>
    );
};